import { faJournalWhills, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { PrinterFill } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ModalDocumentCover = (props) => {
    const history = useHistory();
    const { handleSubmit, register } = useForm();
    const dateFilters = useRef({});
    const { popData, setPopData } = props;
    const { show } = popData;
    function close() {
        setPopData({ show: false })
    }
    function print(data) {
        data.PDateFrom = document.getElementsByName("DocCover_DateFrom")[0].value;
        data.PDateTo = document.getElementsByName("DocCover_DateTo")[0].value;
        if (data.PDateFrom !== "") {
            data.DateFrom = dateFilters.current.DateFrom;
        }
        if (data.PDateTo !== "") {
            data.DateTo = dateFilters.current.DateTo;
        }
        history.push({
            pathname: `/PrintViewer/DocumentCover/${data.DesignReport??false}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetDocumentCover?dateFrom=${data.DateFrom}&dateTo=${data.DateTo}&numberFrom=${data.NumberFrom}&numberTo=${data.NumberTo}`,
                method: "get",
                fetchBody: JSON.stringify(data)
            }
        });
    }
    return (
        <Modal show={show} onHide={() => { }} >
            <Modal.Header className="headerStyle">
                <span><FontAwesomeIcon icon={faJournalWhills} size="lg" />&nbsp;چاپ روکش سند حسابداری</span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg"/>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(print)}>
                    <Row className="rowBorder">
                        <FormGroup className="col-md-6">
                            <label>از شماره: </label>
                            <Form.Control name="NumberFrom" ref={register({})} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>تا شماره: </label>
                            <Form.Control name="NumberTo" ref={register({})} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>از تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocCover_DateFrom" onChange={value => dateFilters.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>تا تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocCover_DateTo" onChange={value => dateFilters.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                        </FormGroup>
                    </Row>
                    <div className="form-control mt-1" style={{background:"transparent", borderColor:"purple", fontSize:"13px", color:"blue"}}>
                        <input type="checkbox" className="form-check-input" name="DesignReport" ref={register({})} /> &nbsp;طراحی چاپ
                    </div>
                    <Button type="submit" className="group-Btn-large mt-1"><PrinterFill size={18} />&nbsp; چاپ روکش سند</Button>
                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalDocumentCover;